import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

const elementId = 'svg-sprite';
const Cache = Object.create(null);
const getSvgUseElement = (href) => {
    const sprite = document.getElementById(elementId);
    if (sprite) {
        const use = sprite.querySelector(`[*|href="${href}"]`);
        if (!use) {
            console.warn('could not load svg icon.', { href });
        }
        return use;
    }
    return null;
};
const getSvgInfo = (id) => {
    let useProps = Cache[id];
    if (useProps) {
        return useProps;
    }
    const use = getSvgUseElement(id);
    if (!use) {
        return undefined;
    }
    const width = use.getAttribute('width');
    const height = use.getAttribute('height');
    const xlinkHref = use.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
    if (!width || !height || !xlinkHref) {
        return undefined;
    }
    useProps = {
        width: parseInt(width, 0),
        height: parseInt(height, 0),
        xlinkHref,
    };
    Cache[id] = useProps;
    return useProps;
};
const SpriteIcon = React__default.memo((_a) => {
    var { name, className, onClick } = _a, rest = __rest(_a, ["name", "className", "onClick"]);
    const info = getSvgInfo(`#svg-icon-${name}`);
    if (!info) {
        return null;
    }
    return (jsx("svg", Object.assign({ width: info.width, height: info.height, className: className, onClick: onClick }, rest, { children: jsx("use", { xlinkHref: info.xlinkHref }) })));
});
SpriteIcon.displayName = 'SpriteIcon';

export { SpriteIcon as default, getSvgInfo };
//# sourceMappingURL=SpriteIcon.js.map
